import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import servicesList from '../data/services';
import faqsList from '../data/faqs';
import SectionPageTitle from '../components/SectionPageTitle';
import PageNotFound from './PageNotFound';
import Faq from '../components/Faq';
import SocialShare from '../components/SocialShare';
import ServicesWidget from '../components/ServicesWidget';

export default function ServiceLayout() {
	const { serviceName } = useParams(),
			service = servicesList.filter(service => service.slug.includes(serviceName))[0];
			
	if (service) {
		return (
			<>
				<Helmet>
					<title>{service.title}</title>
				</Helmet>

				<SectionPageTitle
					pageTitle={service.title}
				/>

				<section className="container grid-sidebar">
					<article>
						{service.content}

						{faqsList.map((faq, idx) =>
							<Faq
								key={idx}
								question={faq.question}
								answer={faq.answer}
							/>
						)}

						<SocialShare title={service.title} />
					</article>

					<aside>
						<ServicesWidget />
					</aside>
				</section>
			</>
		);
	} else {
		return <PageNotFound />
	}
}
